import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config, ChapterInformation } from './config';
import { of, Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})



export class AppConfigService {

  constructor(private http: HttpClient) { this.loadConfig(); }

  private chapters : Map<string, ChapterInformation> = new Map<string,ChapterInformation>();
  private listChapterList : string[] = [];
  private maxChapter;

  public maxChapter$: Subject<any> = new BehaviorSubject<any[]>([]);
  public listChapterList$: Subject<any> = new BehaviorSubject<any[]>([]);
  public chapters$: Subject<Map<string, ChapterInformation>> = new BehaviorSubject<Map<string, ChapterInformation>>(new Map<string,ChapterInformation>());
  public latestPage$: number;
  public latestChapter$: number;

  private loadConfig()
  {
    this.http.get<Config>('/assets/config.json').subscribe(config => 
      {
        this.latestChapter$ = config.latestChapter;
        this.latestPage$ = config.latestPage;
        config.chapterInformation.forEach(c => {
          this.listChapterList.push(c.chapterNumber);
          this.chapters.set(c.chapterNumber, c);
          this.maxChapter = this.maxChapter > c.chapterNumber ? this.maxChapter : c.chapterNumber;
        });
        this.listChapterList.sort((first, second) => (first > second? -1 : 1));
        this.maxChapter$.next(this.maxChapter);
        this.listChapterList$.next(this.listChapterList);
        this.chapters$.next(this.chapters);
      }
    )
  }
}